import {
  CreateTenantDto,
  DeleteTenantDto,
  EditTenantDto,
  GetTenantDto,
  MessageResponseDto,
  TenantApiFp,
  TenantControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTenantModel = TenantControllerGet200Response;
export type GetTenantModel = GetTenantDto;
export type MutateResponseTenantModel = MessageResponseDto;
export type CreateTenantModel = CreateTenantDto;
export type UpdateTenantModel = EditTenantDto;
export type DeleteTenantModel = DeleteTenantDto;
export type GetTenantFeaturesModel = GetTenantDto;

export const apiTenantFp = TenantApiFp(apiConfig);
export const getTenantController = apiTenantFp.tenantControllerGet;
export const createTenantController = apiTenantFp.tenantControllerCreate;
export const updateTenantController = apiTenantFp.tenantControllerEdit;
export const deleteTenantController = apiTenantFp.tenantControllerDelete;
export const getTenantBySlugController = apiTenantFp.tenantControllerGetBySlug;
export const getTenantFeatBySlugController = apiTenantFp.tenantControllerGetTenantFeatBySlug;

export const QueryKeyTenant = QueryKey.Tenant;
